import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

/**
 * Which copy of Mockingbird this is: "production", or "staging" on the test
 * copy (server: PROOFBOX_ENVIRONMENT, reported by /api/health). The test copy
 * labels itself on every screen - a badge by the logo, an amber line along the
 * top, "[Staging]" in the tab's title - so it's never mistaken for the live app.
 */
export function useEnvironment(): string {
  const { data } = useQuery({
    queryKey: ["environment"],
    queryFn: async () => {
      const r = await fetch("/api/health", { credentials: "same-origin" });
      return r.ok ? ((await r.json()).environment as string | undefined) ?? "production" : "production";
    },
    staleTime: Infinity,
    retry: false,
  });
  const env = data ?? "production";
  useEffect(() => {
    if (env === "production") return;
    const label = `[${env.charAt(0).toUpperCase()}${env.slice(1)}] `;
    if (!document.title.startsWith(label)) document.title = label + document.title;
    document.body.classList.add("env-test-copy");
    return () => document.body.classList.remove("env-test-copy");
  }, [env]);
  return env;
}
